import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import * as graphql from '@treams/treams-network';
import { Paragraph, tokens } from '@treams/treams-ui';

import Managees from './Managees';
import Managers from './Managers';
import Me from './Me';

const Separator = styled(Box)`
	border-bottom: 1px dashed ${tokens.border.subtle};
`;

export default function Roles(props: { id: string }) {
	const { t } = useTranslation();
	const query = graphql.useUserManagersManageesQuery({
		variables: { id: props.id },
		fetchPolicy: 'network-only',
	});

	const user = query.data?.user;
	const roles = query.data?.user.roles as graphql.UserRole[];

	return (
		<Box mb={5} minWidth={200 + 180 * 2 + 8}>
			{user ? (
				<Paragraph mb={3}>
					{t('settings.employees.roles.description', { name: user.firstName })}
				</Paragraph>
			) : (
				<Paragraph.Skeleton lines={1} mb={3} />
			)}

			<Managers user={user as graphql.User} refetch={query.refetch} />

			<Separator my={4} />

			<Me user={user as graphql.User} />

			<Separator my={4} />

			<Managees user={user as graphql.User} roles={roles || []} refetch={query.refetch} />
		</Box>
	);
}
